<template>
<div class="page_ table_textc">
    <div>
        <a-form layout="inline">
            <a-form-item label="保单号 " >
                <a-input class="min_input_" style="width: 200px;" v-model="policyNoi" placeholder="请输入保单号"></a-input>
            </a-form-item>
            <a-form-item label="投保日期">
                <a-range-picker :placeholder="['请选择日期', '请选择日期']" style="width: 215px;" @change="rangeDate" :value="createValue"></a-range-picker>
            </a-form-item>
            <a-form-item label="投保人">
                <a-input class="min_input_" v-model="holderNamei"></a-input>
            </a-form-item>
            <a-form-item label="被保人">
                <a-input class="min_input_" v-model="insuredNamei"></a-input>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="searchData()">查询</a-button>
                <a-button style="margin-left: 8px;" type="default" @click="initData()">重置</a-button>
            </a-form-item>
        </a-form>
    </div>
    <a-table 
        style="margin-top: 17px;" 
        :columns="columns" 
        :dataSource="tableData"
        :pagination="pagination"
        @change="handlePageChange"
        class="table_b table_nowrap"
    >
        <span slot="operation" slot-scope="text, record">
            <span>退保成功</span>
        </span>
    </a-table>
</div>
</template>
<style lang="scss" scoped>
    .min_input_ {
        width: 64px;
    }
    .table_b{
        border:1px solid rgba(0,0,0,0.1);
    }
</style>
<script>
import api from '@/utils/api'
const columns = [{
     title: '保单号',
    key: 'policyNo',
    dataIndex: 'policyNo'
}, {
    title: '产品名称',
    key: 'productName',
    dataIndex: 'productName'
}, {
    title: '保费',
    key: 'price',
    dataIndex: 'price'
}, {
    title: '投保人',
    key: 'holderName',
    dataIndex: 'holderName'
}, {
    title: '起保日期',
    key: 'startDate',
    dataIndex: 'startDate'
}, {
    title: '终保日期',
    key: 'endDate',
    dataIndex: 'endDate'
}, {
    title: '保单状态',
    key: 'status',
    scopedSlots: { customRender: "operation" }
}]

export default {
    data () {
        document.title = '退保管理'
        return {
            columns,
            tableData: [],
            createValue:[],
            pagination: {
                total:0,
                pageSize: 20,
                pageNum: 1
            },
            policyNo:'',
            status:2,
            pageNum:'1',
            pageSize:'20',
            policyNoi:'',
            startDatei:'',
            endDatei:'',
            holderNamei:'',
            insuredNamei:'',
        }
    },
     mounted() {
        this.initData()
    },
    methods: {
        handlePageChange (e) {
            this.pageNum=e.current
            this.initData()
        },
        initData(){
            this.policyNoi=''
            this.createValue=[]
            this.startDatei=''
            this.endDatei=''
            this.holderNamei=''
            this.insuredNamei=''
            let queryData={pageNum:this.pageNum,pageSize:this.pageSize,status:this.status}
            this.queryData(queryData) 
        },
        queryData(queryData){
            api.findUserPolicy(queryData).then(res => {
                if(res.data.returnCode==='0000'||res.data.data.list!=null){
                    this.tableData=res.data.data.list.map((item,index)=>{
                        item.key=index
                        return item
                    })
                    this.pagination.total=res.data.data.total
                }
            })
        },
        searchData(){
           let queryData={pageNum:this.pageNum,pageSize:this.pageSize,status:this.status,policyNo:this.policyNoi,startDate:this.startDatei,endDate:this.endDatei,holderName:this.holderNamei,insuredName:this.insuredNamei}
           this.queryData(queryData) 
        },
        rangeDate(dates,dateStrings) {
            this.createValue=dates
            this.startDatei=dateStrings[0]
            this.endDatei=dateStrings[1]
        },
    }
}
</script>